import styled from "styled-components";

export const StyledCopy = styled.span`
  color: ${({theme}) => theme.text.primary};
  font-size: 14px;
`;